module.exports = __webpack_public_path__ + "img/mission.962a5ed3.jpg";